import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bool, func, string } from 'prop-types';
import { Button, Icon, Text } from '@landtrustinc/design-system';
import InquiryFieldError from './InquiryFieldError';
import InquiryNoCreditCardNote from './InquiryNoCreditCardNote';
import css from './InquiryTripActions.module.css';

const InquiryTripActions = ({
  errorMessage,
  submitDisabled,
  isLast,
  sendEnquiryInProgress,
  isInquirySubmitLocked,
  onContinue,
  onFollow,
  onValidate,
  showValidationSummary,
  landownerName,
}) => (
  <>
    <div className={css.controls}>
      {errorMessage && <InquiryFieldError>{errorMessage}</InquiryFieldError>}
      {showValidationSummary && (
        <InquiryFieldError data-testid="inquiry-validation-summary">
          <FormattedMessage id="InquiryWizard.fixFieldsBeforeContinue" />
        </InquiryFieldError>
      )}
      <Button
        variant="primary"
        type={isLast ? 'submit' : 'button'}
        fullWidth
        data-testid="send-inquiry-button"
        disabled={submitDisabled || sendEnquiryInProgress}
        isLoading={isLast && sendEnquiryInProgress}
        onClick={event => {
          if (isLast && isInquirySubmitLocked()) {
            event.preventDefault();
            return;
          }
          if (isLast && !onValidate()) {
            event.preventDefault();
            return;
          }
          if (isLast) {
            onFollow();
            return;
          }
          onContinue();
        }}
      >
        {isLast ? (
          <FormattedMessage id="InquiryWizard.sendInquiry" />
        ) : (
          <FormattedMessage id="InquiryWizard.continue" />
        )}
      </Button>
      <InquiryNoCreditCardNote />
    </div>

    <div className={css.reassurance}>
      <div className={css.notBooking}>
        <span className={css.noteIcon}>
          <Icon variant="CircleInfo" size="small" />
        </span>
        <Text size="sm" color="var(--color-hunter-500)">
          <Text as="span" size="sm" fontWeight="bold" color="var(--color-hunter-500)">
            <FormattedMessage id="InquiryWizard.notABookingRequestLead" />
          </Text>{' '}
          <FormattedMessage
            id="InquiryWizard.notABookingRequest"
            values={{ name: landownerName }}
          />
        </Text>
      </div>
    </div>
  </>
);

InquiryTripActions.defaultProps = {
  errorMessage: null,
  sendEnquiryInProgress: false,
  isInquirySubmitLocked: () => false,
  onValidate: () => true,
  showValidationSummary: false,
};

InquiryTripActions.propTypes = {
  errorMessage: string,
  submitDisabled: bool.isRequired,
  isLast: bool.isRequired,
  sendEnquiryInProgress: bool,
  isInquirySubmitLocked: func,
  onContinue: func.isRequired,
  onFollow: func.isRequired,
  onValidate: func,
  showValidationSummary: bool,
  landownerName: string.isRequired,
};

export default InquiryTripActions;
